import React from 'react';
import TableSearch from "@/components/table/tableSearch";
import {URLS} from "@/lib/urls";
import {Button} from "antd";
import {Can, hasPermissionLink} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import {useApiSearchAdminGroups} from "@/api/group";
import {Link, useNavigate} from "react-router-dom";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {sprintf} from "@/lib/utils/sprintf";
import GroupStatusEnumComponent from "@/components/EnumComponents/GroupStatusEnumComponent";

export default function AdminGroupListPage(props) {
    const navigate = useNavigate();

    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            width: 80,
            align: 'center',
        },
        {
            title: 'عنوان گروه',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'توضیحات',
            dataIndex: 'desc',
            key: 'desc',
            ellipsis: true,
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            align: 'center',
            render: (status) => (
                <GroupStatusEnumComponent text={status} />

            ),
        },
        {
            title: 'عملیات',
            dataIndex: 'id',
            key: 'actions',
            width: 120,
            render: (text, record) => {
                return (
                    <div className="flex gap-2">

                        <Link
                            to={hasPermissionLink(PermList.GROUP_EDIT, sprintf(URLS.admin.group.edit, {id: record?.id}))}
                        >
                            <Button size={'small'} variant={'outlined'} color={'default'}>
                                مشاهده
                            </Button>
                        </Link>
                    </div>
                );
            }
        }
    ];

    return (
        <>
            <AdminLayout pageTitle={'گروه‌های علمی'} backTo={URLS.admin.setting.dashboard}>
                <TableSearch
                    searchInput={true}
                    addButton={
                        <div className={'flex justify-end gap-1'}>
                            <Can permission={PermList.GROUP_CREATE}>
                                <Button
                                    color={'primary'}
                                    variant={'solid'}
                                    size={'middle'}
                                    onClick={() => navigate(URLS.admin.group.create)}>
                                    افزودن گروه علمی

                                </Button>
                            </Can>


                        </div>
                    }
                    apiFn={useApiSearchAdminGroups}
                    columns={columns}
                    scroll={{x: true}}
                    responsive={true}
                />
            </AdminLayout>
        </>
    );
}